import React, { PureComponent } from 'react';

import { Svg, filterProps } from '@lglp/components';
import PropTypes from 'prop-types';

import { ICON } from 'translations';

import { translate } from '../mixins/composer';

export class MemoComponent extends PureComponent {
  static displayName = 'MemoComponent';

  static handledProps = ['title'];

  static propTypes = {
    title: PropTypes.string,
  };

  static defaultProps = {
    title: ICON.MEMO,
  };

  render() {
    const { title, t } = this.props;
    const rest = filterProps(MemoComponent, this.props);

    return (
      <Svg title={t(title)} viewBox="0 0 112.86 85.03" {...rest}>
        <defs />
        <g id="Calque_2" data-name="Calque 2">
          <g id="Calque_1-2">
            <path
              d="M10.78 1H9.14A8.23 8.23 0 0 0 1 9.3V84h102.72a8.23 8.23 0 0 0 8.14-8.31V1H10.78z"
              stroke="#fff"
              fill="none"
              strokeLinecap="round"
              strokeMiterlimit={10}
              strokeWidth={2}
            />
            <path
              className="memo-2"
              d="M23.54 48.82h27.39m-27.39 9.86h27.39m-27.39 9.85h27.39m12.6-19.71h27.39m-27.39 9.86h27.39m-27.39 9.85h27.39"
            />
            <circle className="memo-2" cx={38.35} cy={27.62} r={10.1} />
            <path
              className="memo-2"
              d="M45.41 34.84l-7.52-7.52 7.06-7.07m25.79 4.18h7.82v10.86h-7.82zm8.04-7.91h7.82v18.77h-7.82z"
            />
          </g>
        </g>
      </Svg>
    );
  }
}

export default translate(MemoComponent);
